import { render, staticRenderFns } from "./BilletConfigCreateUpdate.vue?vue&type=template&id=7bf12aa2&"
import script from "./BilletConfigCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./BilletConfigCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports